import { Checkbox } from '../ui/checkbox';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import {
  Select,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '../ui/select';
import ClinicalSelectContent from './ClinicalSelectContent';

/**
 * Antecedente estructurado v2: condiciones, evolución, tratamiento, control.
 */
export default function PathologyBlock({ label, value, onChange, conditionOptions = [] }) {
  const v = value || {};
  const conditions = Array.isArray(v.conditions) ? v.conditions : [];

  const toggleCondition = (id) => {
    const next = conditions.includes(id)
      ? conditions.filter((c) => c !== id)
      : [...conditions, id];
    onChange({ ...v, conditions: next, checked: next.length > 0 || !!v.checked });
  };

  return (
    <div className="rounded-lg border border-border p-3 space-y-3">
      <label className="flex items-center gap-2 cursor-pointer font-medium">
        <Checkbox
          checked={!!v.checked || conditions.length > 0}
          onCheckedChange={(c) => onChange({ ...v, checked: Boolean(c) })}
        />
        {label}
      </label>
      {(v.checked || conditions.length > 0) && conditionOptions.length > 0 ? (
        <div className="flex flex-wrap gap-2 pl-6">
          {conditionOptions.map((opt) => (
            <label
              key={opt.id}
              className="flex items-center gap-1.5 text-sm cursor-pointer border rounded-md px-2 py-1"
            >
              <Checkbox
                checked={conditions.includes(opt.id)}
                onCheckedChange={() => toggleCondition(opt.id)}
              />
              {opt.label}
            </label>
          ))}
        </div>
      ) : null}
      {(v.checked || conditions.length > 0) && (
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 pl-0 sm:pl-6">
          <div>
            <Label className="text-xs">Tiempo de evolución</Label>
            <Input
              className="h-9 mt-0.5"
              placeholder="Ej. 2 años"
              value={v.evolution_time || ''}
              onChange={(e) => onChange({ ...v, evolution_time: e.target.value })}
            />
          </div>
          <div>
            <Label className="text-xs">Tratamiento actual</Label>
            <Input
              className="h-9 mt-0.5"
              value={v.treatment || ''}
              onChange={(e) => onChange({ ...v, treatment: e.target.value })}
            />
          </div>
          <div>
            <Label className="text-xs">¿Controlado?</Label>
            <Select
              value={v.controlled || ''}
              onValueChange={(val) => onChange({ ...v, controlled: val === 'none' ? '' : val })}
            >
              <SelectTrigger className="h-9 mt-0.5">
                <SelectValue placeholder="Seleccionar" />
              </SelectTrigger>
              <ClinicalSelectContent>
                <SelectItem value="none">—</SelectItem>
                <SelectItem value="si">Sí</SelectItem>
                <SelectItem value="no">No</SelectItem>
                <SelectItem value="na">No aplica</SelectItem>
              </ClinicalSelectContent>
            </Select>
          </div>
          <div className="sm:col-span-2">
            <Label className="text-xs">Detalle clínico</Label>
            <Input
              className="h-9 mt-0.5"
              placeholder="Especifique"
              value={v.detail || ''}
              onChange={(e) => onChange({ ...v, detail: e.target.value })}
            />
          </div>
        </div>
      )}
    </div>
  );
}
